module.exports = __webpack_public_path__ + "media/images/category/dummy/shoes02-c8caa114ae756c5627fecda8eca20237.jpg";